// MB-I18N-CRM — CRM / Platform FR. Clés plates, namespaces crm.* et platform.*.
export default {
  "platform.brand": "SUPERKAWA® Plateforme",
  "platform.network_space": "Espace réseau",
  "platform.admin_fallback": "Admin plateforme",
  "platform.back_os": "Retour OS",
  "platform.tools": "Outils plateforme",
  "platform.tabs.dossiers": "Dossiers",
  "platform.tabs.priorites": "Priorités CRM",
  "platform.tabs.fiabilite": "Fiabilité CRM",
  "platform.tabs.conseiller": "Conseiller",
  "platform.tabs.boutiques": "Boutiques",
  "platform.tabs.whatsapp": "WhatsApp",
  "platform.tabs.programme": "Programme",
  "crm.actions.refresh": "Rafraîchir",
  "crm.actions.copy": "Copier",
  "crm.actions.copied": "Copié",
  "crm.actions.save": "Enregistrer",
  "crm.actions.cancel": "Annuler",
  "crm.actions.close": "Fermer",
  "crm.actions.create": "Créer",
  "crm.actions.search": "Rechercher",

  "crm.leads.deprecated_title": "Module Legacy — déprécié",
  "crm.leads.deprecated_desc": "Les Dossiers Clients sont désormais l'unique source de vérité CRM. Cet écran est conservé en lecture pour l'historique existant uniquement.",
  "crm.leads.title": "Leads ({count})",
  "crm.leads.empty_title": "Aucun lead pour l'instant.",
  "crm.leads.empty_hint": "Les leads apparaîtront ici après soumission du formulaire sur le simulateur.",
  "crm.leads.col_firstname": "Prénom",
  "crm.leads.col_phone": "Téléphone",
  "crm.leads.col_country": "Pays",
  "crm.leads.col_pack": "Pack",
  "crm.leads.col_qualification": "Qualification",
  "crm.leads.col_date": "Date",
  "crm.leads.col_status": "Statut",
  "crm.leads.col_dossier": "Dossier",
  "crm.leads.status.new": "Nouveau",
  "crm.leads.status.contacted": "Contacté",
  "crm.leads.status.qualified": "Qualifié",
  "crm.leads.status.lost": "Perdu",

  "crm.wa.title": "WhatsApp — Templates & Réponses rapides",
  "crm.wa.subtitle": "Messages pré-rédigés à copier-coller dans vos conversations WhatsApp.",
  "crm.wa.grid_title": "Grille de qualification",
  "crm.wa.low_desc": "Pas de budget clair, pas de timeline, intention vague.",
  "crm.wa.low_action": "Action : filtre débutant",
  "crm.wa.medium_desc": "Projet structuré, budget approximatif, timeline floue.",
  "crm.wa.medium_action": "Action : mini estimation",
  "crm.wa.high_desc": "Budget clair, timeline définie, intention sérieuse.",
  "crm.wa.high_action": "Action : transition vers offre",
  "crm.wa.flow_title": "Flux de conversion",
  "crm.wa.flow.blog_quiz": "Blog / Quiz",
  "crm.wa.flow.whatsapp": "WhatsApp",
  "crm.wa.flow.qualification": "Qualification",
  "crm.wa.flow.mini_estimate": "Mini estimation",
  "crm.wa.flow.offer": "Offre",
  "crm.wa.tpl.default.title": "Auto-reply par défaut",
  "crm.wa.tpl.default.desc": "Premier message pour un contact direct (blog, site)",
  "crm.wa.tpl.default.text": "Bonjour, merci pour votre message.\n\nJe peux vous faire une estimation rapide pour votre projet de coffee shop.\n\nPour avancer, dites-moi :\n1. Ville / pays ?\n2. Budget approximatif ?\n3. Ouverture prévue (quand) ?\n4. Avez-vous déjà un local ou non ?",
  "crm.wa.tpl.quiz.title": "Lead quiz / simulateur",
  "crm.wa.tpl.quiz.desc": "Pour les contacts venant du simulateur",
  "crm.wa.tpl.quiz.text": "Bonjour, merci pour votre message.\n\nJ'ai bien vu votre simulation.\n\nPour affiner votre projet, dites-moi :\n1. Ville / pays ?\n2. Budget approximatif ?\n3. Ouverture prévue ?\n4. Avez-vous déjà un local ?",
  "crm.wa.tpl.mini_estimate.title": "Mini estimation (gratuite)",
  "crm.wa.tpl.mini_estimate.desc": "Réponse rapide après qualification MEDIUM/HIGH",
  "crm.wa.tpl.mini_estimate.text": "Avec votre budget, vous pouvez viser un coffee shop de niveau [simple/intermédiaire/premium].\n\nOrdre de grandeur :\n- Matériel : [X]\n- Aménagement : [X]\n- Lancement : [X]\n\nLe point clé reste le concept et la différenciation.",
  "crm.wa.tpl.beginner.title": "Filtre débutant",
  "crm.wa.tpl.beginner.desc": "Pour les leads peu qualifiés (LOW)",
  "crm.wa.tpl.beginner.text": "Je vous conseille d'abord de clarifier votre projet (budget, emplacement, timing).\n\nRevenez vers moi dès que c'est plus structuré, je pourrai alors vous donner une estimation précise.",
  "crm.wa.tpl.transition.title": "Transition vers offre",
  "crm.wa.tpl.transition.desc": "Quand le lead est prêt à avancer (HIGH)",
  "crm.wa.tpl.transition.text": "Si vous avancez sérieusement, je peux vous accompagner sur toute la structuration :\n\n- Sélection d'équipement adapté\n- Standardisation des recettes\n- Structuration du concept\n- Accompagnement au lancement\n\nOn en parle ?",

  "crm.partner.title": "Programme Partenaire",
  "crm.partner.subtitle": "Structure interne — usage sales, CRM et propositions commerciales",
  "crm.partner.load_error": "Impossible de charger le programme",
  "crm.partner.matrix_title": "Matrice comparative",
  "crm.partner.section.concept": "1. Concept",
  "crm.partner.section.equipment": "2. Équipement",
  "crm.partner.section.training": "3. Accompagnement",
  "crm.partner.section.experience": "4. Expérience & Branding",
  "crm.partner.section.support": "5. Support & Évolution",
  "crm.partner.row.positioning": "Positionnement",
  "crm.partner.row.menu": "Carte",
  "crm.partner.row.differentiator": "Différenciation",
  "crm.partner.row.daily_covers": "Objectif clients/jour",
  "crm.partner.row.coffee_machine": "Machine espresso",
  "crm.partner.row.grinder": "Moulin",
  "crm.partner.essential_setup": "Setup essentiel",
  "crm.partner.row.level": "Niveau",
  "crm.partner.row.duration": "Durée",
  "crm.partner.duration_value": "{days} jours — {format}",
  "crm.partner.row.signature_recipes": "Recettes signature SUPERKAWA incluses",
  "crm.partner.recipes_value": "{count} recettes ({cats})",
  "crm.partner.training_content": "Contenu accompagnement",
  "crm.partner.row.visual_identity": "Identité visuelle",
  "crm.partner.row.customer_experience": "Expérience client",
  "crm.partner.row.product_presentation": "Présentation produit",
  "crm.partner.row.digital": "Digital",
  "crm.partner.row.onboarding": "Onboarding",
  "crm.partner.row.ongoing_support": "Support continu",
  "crm.partner.row.improvements": "Améliorations",
  "crm.partner.row.upgrade_path": "Évolution",
  "crm.pipeline.new": "Nouveau",
  "crm.pipeline.contacted": "Contacté",
  "crm.pipeline.qualified": "Qualifié",
  "crm.pipeline.won": "Gagné",
  "crm.pipeline.lost": "Perdu",
  "crm.pipeline.archived": "Archivé",
  "crm.qualification.high": "Élevée",
  "crm.qualification.medium": "Moyenne",
  "crm.qualification.low": "Faible",
  "crm.qualification.unknown": "Inconnue",
  "crm.type.prospect": "Prospect",
  "crm.type.client": "Client",
  "crm.type.archived": "Archivé",
  "crm.integrity.clean": "Sain",
  "crm.integrity.review_required": "À vérifier",
  "crm.integrity.ambiguous": "Ambigu",
  "crm.integrity.conflict": "Conflit",
  "crm.integrity.merged": "Fusionné",
  "crm.integrity.orphaned": "Orphelin",
  "crm.dossier.fallback_name": "Dossier",
  "crm.dossier.fallback_name_id": "Dossier #{id}",
  "crm.completeness.item.identity": "Identité",
  "crm.completeness.item.business_profile": "Business Profile",
  "crm.completeness.item.store": "Boutique",
  "crm.completeness.item.owner": "Propriétaire",
  "crm.completeness.item.subscription": "Abonnement",
  "crm.completeness.item.timeline": "Timeline",
  "crm.completeness.item.commerce": "Commerce",
  "crm.completeness.item.communication": "Communication",
  "crm.completeness.item.support": "Support",
  "crm.due.none": "Sans échéance",
  "crm.due.overdue": "En retard",
  "crm.due.today": "Aujourd’hui",
  "crm.due.tomorrow": "Demain",
  "crm.due.in_days": "Dans {days} jours",
  "crm.decision.priority.low": "Faible",
  "crm.decision.priority.normal": "Normale",
  "crm.decision.priority.high": "Haute",
  "crm.decision.priority.critical": "Critique",
  "crm.decision.potential.a_confirmer": "À confirmer",
  "crm.decision.potential.faible": "Faible",
  "crm.decision.potential.modere": "Modéré",
  "crm.decision.potential.eleve": "Élevé",
  "crm.decision.confidence.elevee": "Élevée",
  "crm.decision.confidence.moyenne": "Moyenne",
  "crm.decision.confidence.faible": "Faible",
  "crm.decision.confidence.insuffisante": "Insuffisante",
  "crm.decision.family.acquisition": "Acquisition",
  "crm.decision.family.pipeline": "Pipeline",
  "crm.decision.family.commerce": "Commerce",
  "crm.decision.family.communication": "Communication",
  "crm.decision.family.support": "Support",
  "crm.decision.family.produit": "Produit",
  "crm.decision.family.integrity": "Intégrité",
  "crm.decision.status.acknowledged": "Pris en compte",
  "crm.decision.status.acknowledged_hint": "Vue par le conseiller — le signal reste actif.",
  "crm.decision.status.dismissed": "Ignorée",
  "crm.decision.status.dismissed_until": "Ignorée jusqu'au {date}",
  "crm.decision.status.dismissed_hint": "Elle réapparaîtra après cette date si le signal reste vrai.",
  "crm.decision.status.resolved": "Résolue automatiquement",
  "crm.decision.status.resolved_hint": "Le signal n'est plus vrai — personne ne l'a supprimée.",
  "crm.decision.status.expired": "Expirée",
  "crm.decision.status.expired_hint": "Ce signal n'était plus pertinent au-delà de sa période de validité.",
  "crm.decision.chrono.detected": "Détectée",
  "crm.decision.chrono.acknowledged": "Prise en compte",
  "crm.decision.chrono.dismissed": "Ignorée",
  "crm.decision.chrono.resolved": "Résolue automatiquement",
  "crm.decision.chrono.expired": "Expirée",
  "crm.decision.not_evaluated": "{count} dossier(s) jamais analysé(s) — l'analyse se lance à l'ouverture du dossier.",
  "crm.quote.status.draft": "Brouillon",
  "crm.quote.status.sent": "Envoyé",
  "crm.quote.status.accepted": "Accepté",
  "crm.quote.status.declined": "Refusé",
  "crm.quote.status.expired": "Expiré",
  "crm.quote.status.cancelled": "Annulé",
  "crm.quote.action.sent": "Marquer envoyé",
  "crm.quote.action.accepted": "Marquer accepté",
  "crm.quote.action.declined": "Marquer refusé",
  "crm.quote.action.expired": "Marquer expiré",
  "crm.quote.action.cancelled": "Annuler le devis",
  "crm.quote.item_type.saas": "SaaS",
  "crm.quote.item_type.hardware_solution": "Solution matérielle",
  "crm.quote.item_type.custom": "Ligne libre",
  "crm.ticket.category.technical_support": "Support technique",
  "crm.ticket.category.billing": "Facturation",
  "crm.ticket.category.account": "Compte",
  "crm.ticket.category.hardware": "Matériel",
  "crm.ticket.category.training": "Formation",
  "crm.ticket.category.feature": "Fonctionnalité",
  "crm.ticket.category.bug": "Bug",
  "crm.ticket.category.other": "Autre",
  "crm.ticket.priority.low": "Faible",
  "crm.ticket.priority.normal": "Normale",
  "crm.ticket.priority.high": "Haute",
  "crm.ticket.priority.critical": "Critique",
  "crm.ticket.status.open": "Ouvert",
  "crm.ticket.status.in_progress": "En cours",
  "crm.ticket.status.waiting": "En attente",
  "crm.ticket.status.resolved": "Résolu",
  "crm.ticket.status.closed": "Fermé",
  "crm.comm.type.email": "Email",
  "crm.comm.type.phone_call": "Appel",
  "crm.comm.type.whatsapp": "WhatsApp",
  "crm.comm.type.meeting": "Réunion",
  "crm.comm.type.note": "Note",
  "crm.comm.status.draft": "Brouillon",
  "crm.comm.status.planned": "Planifié",
  "crm.comm.status.completed": "Terminé",
  "crm.comm.status.cancelled": "Annulé",
  "crm.comm.direction.incoming": "Entrant",
  "crm.comm.direction.outgoing": "Sortant",
  "crm.comm.direction.internal": "Interne",
  "crm.common.loading": "Chargement…",
  "crm.actions.open": "Ouvrir",
  "crm.actions.refresh_alt": "Actualiser",
  "crm.pagination.prev": "Précédent",
  "crm.pagination.next": "Suivant",
  "crm.pagination.page": "Page {page} / {total}",

  "crm.dossiers.title": "Dossiers Clients",
  "crm.dossiers.subtitle": "Entrée officielle du CRM · {count} dossier(s)",
  "crm.dossiers.new_prospect": "Nouveau prospect",
  "crm.dossiers.load_error": "Erreur de chargement. Réessayez.",
  "crm.dossiers.empty": "Aucun dossier ne correspond aux filtres.",
  "crm.dossiers.unassigned": "Non assigné",
  "crm.dossiers.col_name": "Nom",
  "crm.dossiers.col_type": "Type",
  "crm.dossiers.col_pipeline": "Pipeline",
  "crm.dossiers.col_qualification": "Qualif.",
  "crm.dossiers.col_assignee": "Assignation",
  "crm.dossiers.col_next_action": "Prochaine action",
  "crm.dossiers.col_integrity": "Intégrité",
  "crm.dossiers.col_updated": "Mise à jour",
  "crm.dossiers.filter.type_label": "Type",
  "crm.dossiers.filter.type_all": "Type · Tous",
  "crm.dossiers.filter.pipeline_label": "Pipeline",
  "crm.dossiers.filter.pipeline_all": "Pipeline · Tous",
  "crm.dossiers.filter.qualification_label": "Qualification",
  "crm.dossiers.filter.qualification_all": "Qualif. · Toutes",
  "crm.dossiers.filter.integrity_label": "Intégrité",
  "crm.dossiers.filter.integrity_all": "Intégrité · Toutes",
  "crm.dossiers.filter.assignee_label": "Assignation",
  "crm.dossiers.filter.assignee_all": "Assignation · Toutes",
  "crm.dossiers.filter.due_label": "Échéance",
  "crm.dossiers.filter.due_all": "Échéance · Toutes",
  "crm.dossiers.filter.due_week": "Cette semaine",
  "crm.dossiers.filter.due_none": "Sans action",

  "crm.stores.title": "Boutiques ({count})",
  "crm.stores.loading": "Chargement des boutiques…",
  "crm.stores.empty": "Aucune boutique pour l'instant.",
  "crm.stores.owner": "Owner",
  "crm.stores.not_attached": "Non rattaché",
  "crm.stores.formule_label": "Formule",
  "crm.stores.formule.libre": "Libre",
  "crm.stores.formule.recette": "Recettes",
  "crm.stores.formule.recette_stock": "Recettes + Stock",
  "crm.stores.status.active": "Actif",
  "crm.stores.status.trial": "Essai",
  "crm.stores.status.paused": "Suspendu",
  "crm.stores.status.cancelled": "Annulé",
  "crm.stores.suspend": "Suspendre",
  "crm.stores.activate": "Activer",
  "crm.stores.manage": "Gérer",
  "crm.stores.manage_title": "Ouvrir cette boutique dans l'OS",
  "crm.stores.attach": "Rattacher",
  "crm.stores.attaching": "Rattachement…",
  "crm.stores.attach_title": "Me rattacher à cette boutique",
  "crm.stores.attach_required": "Rattachement requis",
  "crm.stores.toast.attach_done": "Rattachement effectué.",
  "crm.stores.toast.relogin": "Reconnectez-vous pour activer la gestion complète de cette boutique.",
  "crm.stores.toast.attach_error": "Échec du rattachement.",
  "crm.stores.toast.load_error": "Impossible de charger les boutiques.",
  "crm.stores.toast.update_error": "Échec de la mise à jour.",
  "crm.stores.toast.plan_applied": "Formule « {formule} » appliquée à {store}.",
  "crm.stores.toast.paused": "{store} suspendue.",
  "crm.stores.toast.reactivated": "{store} réactivée.",

  "crm.analytics.title": "Conseiller SUPERKAWA — Analytics produit",
  "crm.analytics.empty": "Aucune donnée analytics pour l'instant.",
  "crm.analytics.days": "{n} jours",
  "crm.analytics.one_year": "1 an",
  "crm.analytics.sessions": "Sessions",
  "crm.analytics.leads_conversion": "Leads · conversion {pct}%",
  "crm.analytics.events": "Événements enregistrés",
  "crm.analytics.funnel": "Entonnoir du parcours",
  "crm.analytics.abandons": "Abandons ({count})",
  "crm.analytics.no_abandon": "Aucun abandon.",
  "crm.analytics.profiles": "Profils d'établissement",
  "crm.analytics.priorities": "Priorités les plus fréquentes",
  "crm.analytics.modules": "Modules les plus recommandés",
  "crm.analytics.human_validation": "Validation humaine nécessaire",
  "crm.analytics.human_rate": "{pct}% des recos",
  "crm.analytics.avg_time": "Temps moyen",
  "crm.analytics.time_full": "Parcours complet (jusqu'à la reco)",
  "crm.analytics.time_to_lead": "Jusqu'au lead",
  "crm.analytics.time_to_abandon": "Jusqu'à l'abandon",
  "crm.analytics.conv_by_profile": "Conversion par profil",
  "crm.analytics.conv_by_priority": "Conversion par priorité",
  "crm.analytics.footer": "Analytics produit anonyme · aucune donnée personnelle, aucune IP · fenêtre {days} jours",
  "crm.analytics.mins_secs": "{m} min {s}s",
  "crm.analytics.secs": "{s}s",
  "crm.analytics.priority.pos": "Encaissement",
  "crm.analytics.priority.loyalty": "Fidélité",
  "crm.analytics.priority.margins": "Marges & stocks",
  "crm.analytics.priority.qr": "Paiement / menu QR",
  "crm.analytics.module.pos": "Caisse (POS)",
  "crm.analytics.module.wallet": "Wallet",
  "crm.analytics.module.loyalty": "Fidélité",
  "crm.analytics.module.qr": "Paiement QR",
  "crm.analytics.module.recipes": "Recettes",
  "crm.analytics.module.foodcost": "Coût matière",
  "crm.analytics.module.stock": "Stocks",
  "crm.analytics.module.analytics": "Analytics",
  "crm.analytics.module.multisite": "Multi-sites",
  "crm.analytics.module.permissions": "Permissions",
  "crm.analytics.module.orders": "Commandes",
  "crm.analytics.module.multicurrency": "Multi-devises",
  "crm.actions.retry": "Réessayer",
  "crm.age.today": "aujourd'hui",
  "crm.age.days_ago": "il y a {days} j",

  "crm.priorities.title": "Priorités CRM",
  "crm.priorities.subtitle": "Dossiers à traiter en premier, d'après l'activité réelle · {count} dossier(s)",
  "crm.priorities.refreshed": "Priorités actualisées.",
  "crm.priorities.kpi.critical": "Dossiers critiques",
  "crm.priorities.kpi.high": "Haute priorité",
  "crm.priorities.kpi.active": "Actions actives",
  "crm.priorities.kpi.critical_tickets": "Tickets critiques",
  "crm.priorities.kpi.quotes": "Devis à traiter",
  "crm.priorities.filter.priority_label": "Priorité",
  "crm.priorities.filter.priority_all": "Priorité · Toutes",
  "crm.priorities.filter.family_label": "Famille",
  "crm.priorities.filter.family_all": "Famille · Toutes",
  "crm.priorities.filter.confidence_label": "Confiance",
  "crm.priorities.filter.confidence_all": "Confiance · Toutes",
  "crm.priorities.filter.status_label": "Statut",
  "crm.priorities.filter.status_all": "Statut · Actives et vues",
  "crm.priorities.filter.status_active": "Actives",
  "crm.priorities.filter.status_ack": "Vues",
  "crm.priorities.error": "Impossible de charger les priorités CRM.",
  "crm.priorities.empty_title": "Aucune action urgente détectée.",
  "crm.priorities.empty_desc": "Les dossiers évalués ne présentent actuellement aucun signal nécessitant une attention particulière.",
  "crm.priorities.col_dossier": "Dossier",
  "crm.priorities.col_priority": "Priorité",
  "crm.priorities.col_action": "Action suggérée",
  "crm.priorities.col_family": "Famille",
  "crm.priorities.col_confidence": "Confiance",
  "crm.priorities.col_last_activity": "Dernière activité",
  "crm.priorities.col_age": "Ancienneté",
  "crm.priorities.actions_count": "{count} action(s)",
  "crm.priorities.critical_ticket": " · Ticket critique",
  "crm.priorities.quote_action": " · Devis à traiter",
  "crm.priorities.advised_action": "Action conseillée : {label}",
  "crm.priorities.ack": "Prendre en compte",
  "crm.priorities.seen": "Pris en compte",
  "crm.priorities.seen_title": "Vue par le conseiller — le signal reste actif.",
  "crm.priorities.open_dossier": "Ouvrir le dossier",
  "crm.priorities.ack_success": "Suggestion prise en compte.",
  "crm.priorities.ack_error": "Impossible de prendre en compte cette suggestion. Réessayez.",
  "crm.priorities.critical_pin": "{count} dossier(s) critique(s)",

  "crm.reliability.title": "Fiabilité CRM",
  "crm.reliability.subtitle": "Usage réel et qualité des suggestions du CRM — lecture seule",
  "crm.reliability.refreshed": "Métriques actualisées.",
  "crm.reliability.period.7d": "7 jours",
  "crm.reliability.period.30d": "30 jours",
  "crm.reliability.period.90d": "90 jours",
  "crm.reliability.period.all": "Tout",
  "crm.reliability.error": "Impossible de charger les métriques de fiabilité.",
  "crm.reliability.empty_title": "Aucune donnée suffisante pour calculer les métriques.",
  "crm.reliability.empty_desc": "Les indicateurs apparaîtront dès que des dossiers auront été analysés.",
  "crm.reliability.health.healthy": "Aucune anomalie importante détectée.",
  "crm.reliability.health.warning": "Certaines décisions nécessitent une vérification.",
  "crm.reliability.health.critical": "Des anomalies importantes nécessitent une vérification rapide.",
  "crm.reliability.kpi.evaluated": "Dossiers analysés",
  "crm.reliability.kpi.coverage": "Couverture d'analyse",
  "crm.reliability.kpi.active": "Actions actives",
  "crm.reliability.kpi.ack": "Prises en compte",
  "crm.reliability.kpi.resolved": "Résolues automatiquement",
  "crm.reliability.kpi.anomalies": "Alertes de fiabilité",
  "crm.reliability.day_abbr": "j",
  "crm.reliability.median": "(médiane {v})",
  "crm.reliability.delay_ack": "Délai moyen avant prise en compte",
  "crm.reliability.delay_resolve": "Délai moyen avant résolution",
  "crm.reliability.rules_title": "Règles les plus actives",
  "crm.reliability.rules_empty": "Aucune suggestion émise sur cette période.",
  "crm.reliability.col_rule": "Règle",
  "crm.reliability.col_family": "Famille",
  "crm.reliability.col_decisions": "Décisions",
  "crm.reliability.col_ack": "Prises en compte",
  "crm.reliability.col_dismissed": "Ignorées",
  "crm.reliability.col_resolved": "Résolues",
  "crm.reliability.quality_title": "Qualité des données",
  "crm.reliability.decisions_checked": "{count} décision(s) vérifiée(s)",
  "crm.reliability.quality_ok": "Aucune incohérence détectée dans les suggestions enregistrées.",
  "crm.actions.change": "Changer",
  "crm.actions.associate": "Associer",
  "crm.actions.back": "Retour",
  "crm.subscription.title": "Abonnement",
  "crm.subscription.plan_label": "Formule",
  "crm.subscription.status_label": "État",
  "crm.subscription.store_label": "Boutique",
  "crm.subscription.empty": "Aucun abonnement.",
  "crm.subscription.plan.libre": "Libre",
  "crm.subscription.plan.recettes": "Recettes",
  "crm.subscription.plan.recettes_stock": "Recettes + Stock",
  "crm.subscription.status.active": "Active",
  "crm.subscription.status.trial": "Essai",
  "crm.subscription.status.past_due": "Impayé",
  "crm.subscription.status.cancelled": "Annulé",
  "crm.subscription.status.paused": "Suspendue",
  "crm.identity.title": "Identité",
  "crm.identity.name": "Nom",
  "crm.identity.company": "Société",
  "crm.identity.type": "Type",
  "crm.identity.crm_status": "Statut CRM",
  "crm.identity.qualification": "Qualification",
  "crm.identity.assignee": "Assignation",
  "crm.identity.id": "Identifiant",
  "crm.identity.created": "Créé le",
  "crm.identity.updated": "Mis à jour le",
  "crm.completeness.title": "Complétude",
  "crm.breadcrumb.aria": "Fil d'Ariane",
  "crm.integrity.title": "Intégrité",
  "crm.integrity.stat_links": "Liens",
  "crm.integrity.stat_references": "Références",
  "crm.integrity.stat_unresolved": "Non résolus",
  "crm.dossier_error.404_title": "Dossier introuvable",
  "crm.dossier_error.404_msg": "Ce Dossier Client n'existe pas ou a été fusionné.",
  "crm.dossier_error.403_title": "Accès refusé",
  "crm.dossier_error.403_msg": "Vous devez être administrateur plateforme pour consulter ce dossier.",
  "crm.dossier_error.generic_title": "Une erreur est survenue",
  "crm.dossier_error.generic_msg": "Impossible de charger le Dossier Client. Réessayez plus tard.",
  "crm.header.pipeline_prefix": "Pipeline · {label}",
  "crm.header.qualif_prefix": "Qualif. · {label}",
  "crm.header.score": "Score CRM",
  "crm.business.title": "Business Profile",
  "crm.business.legal_name": "Raison sociale",
  "crm.business.country": "Pays",
  "crm.business.currency": "Devise",
  "crm.business.registration": "N° immatriculation",
  "crm.business.vat": "Identifiant TVA",
  "crm.business.empty": "Aucun Business Profile associé.",
  "crm.owner.title": "Propriétaire",
  "crm.owner.empty": "Aucun propriétaire rattaché.",
  "crm.owner.account_disabled": "Compte désactivé",
  "crm.owner.account_active": "Compte actif",
  "crm.owner.registered_on": "inscrit le {date}",
  "crm.owner.shops": "{count} boutique(s)",
  "crm.open_dossier.label": "Ouvrir le Dossier Client",
  "crm.open_dossier.searching": "Recherche du dossier…",
  "crm.open_dossier.unavailable": "Dossier Client indisponible",
  "crm.unlink.trigger": "Retirer",
  "crm.unlink.trigger_title": "Retirer la liaison",
  "crm.unlink.title": "Retirer la liaison ?",
  "crm.unlink.desc_named": "« {label} » ne sera plus référencé par ce dossier CRM. L'objet lui-même n'est ni supprimé ni modifié (aucun impact produit, tenant ou accès).",
  "crm.unlink.desc_generic": "Cet élément ne sera plus référencé par ce dossier CRM. L'objet lui-même n'est ni supprimé ni modifié (aucun impact produit, tenant ou accès).",
  "crm.unlink.confirm": "Retirer la liaison",
  "crm.unlink.toast_success": "Liaison retirée.",
  "crm.unlink.toast_error": "Échec du retrait. Réessayez.",
  "crm.convert.btn": "Convertir en client",
  "crm.convert.confirm_title": "Convertir en client ?",
  "crm.convert.confirm_desc": "Cette opération transforme définitivement ce prospect en client. Elle ne crée aucune boutique, aucun abonnement ni aucun utilisateur.",
  "crm.convert.submit": "Convertir",
  "crm.convert.force_title": "Aucun signal client détecté",
  "crm.convert.force_desc": "Ce prospect ne possède encore aucun élément indiquant qu'il est devenu client.",
  "crm.convert.force_submit": "Confirmer malgré tout",
  "crm.convert.toast_success": "Le prospect est maintenant un client.",
  "crm.convert.toast_already": "Ce dossier est déjà un client.",
  "crm.convert.toast_error": "Échec de la conversion. Réessayez.",
  "crm.link.warning.store_without_owner": "Boutique liée sans propriétaire.",
  "crm.link.warning.owner_store_mismatch": "Le propriétaire lié ne correspond à aucune boutique liée.",
  "crm.link.warning.business_profile_identity_mismatch": "L'identité du Business Profile semble distincte du dossier.",
  "crm.link.picker.business.title": "Associer un Business Profile",
  "crm.link.picker.business.desc": "Sélectionnez un profil existant. Aucune donnée n'est copiée : le dossier garde une simple référence.",
  "crm.link.picker.store.title": "Associer une boutique",
  "crm.link.picker.store.desc": "Sélectionnez une boutique existante. Le tenant n'est jamais modifié : le dossier garde une simple référence.",
  "crm.link.picker.owner.title": "Associer un propriétaire",
  "crm.link.picker.owner.desc": "Sélectionnez un compte propriétaire existant. Aucun rôle ni accès n'est modifié : le dossier garde une simple référence.",
  "crm.link.search_placeholder": "Rechercher…",
  "crm.link.searching": "Recherche…",
  "crm.link.load_error": "Impossible de charger les résultats. Réessayez.",
  "crm.link.no_results": "Aucun résultat.",
  "crm.link.already_linked": "Cet élément est déjà associé au dossier.",
  "crm.link.linked": "Liaison enregistrée.",
  "crm.link.replaced": "Liaison remplacée.",
  "crm.link.warning_generic": "Avertissement d'intégrité détecté.",
  "crm.link.assoc_error": "Échec de l'association. Réessayez.",
  "crm.link.replace_prompt": "Une liaison existe déjà pour ce dossier. Voulez-vous la remplacer par « {label} » ? L'objet actuellement lié ne sera pas supprimé : seule la référence CRM change.",
  "crm.link.replace_confirm": "Remplacer la liaison",
  "crm.search.aria": "Recherche universelle CRM",
  "crm.search.placeholder": "Rechercher un nom, une entreprise, un email, un téléphone, un devis ou un ticket…",
  "crm.search.error": "Erreur de recherche. Réessayez.",
  "crm.search.empty": "Aucun dossier trouvé pour « {term} ».",
  "crm.search.no_contact": "Aucune coordonnée",
  "crm.search.via": "via {list}",
  "crm.stores_card.associate": "Associer une boutique",
  "crm.stores_card.empty": "Aucune boutique reliée.",
  "crm.stores_card.fallback_name": "Boutique",
  "crm.stores_card.owner_prefix": "Propriétaire : {list}",
  "crm.stores_card.warning_count": "({count} boutiques)",
  "crm.pipeline.title": "Pipeline & Qualification",
  "crm.pipeline.saving": "Enregistrement…",
  "crm.pipeline.status_label": "Statut (pipeline)",
  "crm.pipeline.qualif_label": "Qualification",
  "crm.pipeline.assignee_label": "Assignation",
  "crm.pipeline.assignee_ph": "Nom du responsable",
  "crm.pipeline.score_label": "Score CRM (0–100)",
  "crm.pipeline.next_action_label": "Prochaine action",
  "crm.pipeline.next_action_ph": "Ex : rappeler le client",
  "crm.pipeline.due_label": "Échéance",
  "crm.pipeline.notes_label": "Notes internes",
  "crm.pipeline.notes_ph": "Contexte commercial, historique d'échange…",
  "crm.pipeline.score_error": "Le score doit être compris entre 0 et 100.",
  "crm.pipeline.save_success": "État commercial enregistré.",
  "crm.pipeline.save_error": "Échec de l'enregistrement. Réessayez.",
  "crm.breadcrumb.cockpit": "Cockpit",
  "crm.breadcrumb.crm": "CRM",
  "crm.breadcrumb.dossier": "Dossier Client",
  "crm.commerce.title": "Commerce",
  "crm.commerce.create_quote": "Créer un devis",
  "crm.commerce.stat_quotes": "Devis",
  "crm.commerce.stat_last": "Dernier devis",
  "crm.commerce.history": "Historique des devis",
  "crm.commerce.valid_until": "valide jusqu'au {date}",
  "crm.commerce.empty": "Aucun devis pour ce dossier.",
  "crm.support.title": "Support",
  "crm.support.new_ticket": "Nouveau ticket",
  "crm.support.stat_tickets": "Tickets",
  "crm.support.stat_open": "Ouverts",
  "crm.support.stat_last": "Dernier ticket",
  "crm.support.history": "Historique des tickets",
  "crm.support.search_ph": "Numéro, titre, assigné, tag…",
  "crm.support.empty_search": "Aucun ticket ne correspond à la recherche.",
  "crm.support.empty": "Aucun ticket pour ce dossier.",
  "crm.support.load_more": "Charger plus ({count}/{total})",
  "crm.comm_card.title": "Communication",
  "crm.comm_card.new": "Nouvelle interaction",
  "crm.comm_card.stat_interactions": "Interactions",
  "crm.comm_card.stat_last": "Dernier échange",
  "crm.comm_card.history": "Historique des communications",
  "crm.comm_card.search_ph": "Sujet, résumé, participant…",
  "crm.comm_card.empty_search": "Aucune interaction ne correspond à la recherche.",
  "crm.comm_card.empty": "Aucune interaction pour ce dossier.",
  "crm.history.created": "Création",
  "crm.history.updated": "Modification",
  "crm.history.deleted": "Suppression",
  "crm.comm_detail.load_error": "Impossible de charger l'interaction.",
  "crm.comm_detail.fallback": "Interaction",
  "crm.comm_detail.desc": "Historique relationnel — lecture seule.",
  "crm.comm_detail.type": "Type",
  "crm.comm_detail.direction": "Direction",
  "crm.comm_detail.occurred": "Date de l'échange",
  "crm.comm_detail.duration": "Durée :",
  "crm.comm_detail.minutes": "{min} min",
  "crm.comm_detail.outcome": "Résultat :",
  "crm.comm_detail.attachments": "Pièces jointes :",
  "crm.comm_detail.logged_by": "Consigné par",
  "crm.comm_detail.on": "le {date}",
  "crm.comm_detail.participants": "Participants",
  "crm.comm_detail.summary": "Résumé",
  "crm.comm_detail.content": "Contenu",
  "crm.comm_detail.history": "Historique",
  "crm.ticket_create.title": "Nouveau ticket",
  "crm.ticket_create.desc": "Demande d'assistance liée au dossier — ouvert au statut « Ouvert ».",
  "crm.ticket_create.title_label": "Titre",
  "crm.ticket_create.title_ph": "Résumé de la demande",
  "crm.ticket_create.desc_label": "Description",
  "crm.ticket_create.desc_ph": "Détail de la demande d'assistance",
  "crm.ticket_create.category": "Catégorie",
  "crm.ticket_create.priority": "Priorité",
  "crm.ticket_create.assignee": "Assigné à",
  "crm.ticket_create.assignee_ph": "Ex. Taha",
  "crm.ticket_create.due": "Échéance",
  "crm.ticket_create.tags": "Tags (séparés par des virgules)",
  "crm.ticket_create.tags_ph": "Ex. urgent, caisse, formation",
  "crm.ticket_create.submit": "Ouvrir le ticket",
  "crm.ticket_create.title_required": "Titre obligatoire.",
  "crm.ticket_create.created": "Ticket ouvert.",
  "crm.ticket_create.create_error": "Création du ticket impossible.",
  "crm.ticket_create.create_error_detail": "Création impossible : {detail}",
  "crm.history.status_changed": "Changement de statut",
  "crm.history.assigned": "Assignation",
  "crm.quote_create.title": "Créer un devis",
  "crm.quote_create.desc": "Proposition commerciale (V1) : le devis est créé en brouillon. Aucune signature ni paiement.",
  "crm.quote_create.label_required": "Chaque ligne doit avoir un libellé.",
  "crm.quote_create.created": "Devis {number} créé (brouillon).",
  "crm.quote_create.error": "Création du devis impossible.",
  "crm.quote_create.error_detail": "Création impossible : {detail}",
  "crm.quote_create.remove_line": "Supprimer la ligne",
  "crm.quote_create.hardware_ph": "Ex. Solution matérielle Essentielle",
  "crm.quote_create.line_label_ph": "Libellé de la ligne",
  "crm.quote_create.description_ph": "Description (optionnel)",
  "crm.quote_create.qty": "Quantité",
  "crm.quote_create.unit_price": "Prix unitaire",
  "crm.quote_create.discount": "Remise",
  "crm.quote_create.line_total": "Total ligne",
  "crm.quote_create.add_line": "Ajouter une ligne",
  "crm.quote_create.currency": "Devise",
  "crm.quote_create.tax": "TVA (%)",
  "crm.quote_create.valid_until": "Valide jusqu'au",
  "crm.quote_create.notes_ph": "Notes internes (optionnel)",
  "crm.quote_create.subtotal": "Sous-total :",
  "crm.quote_create.tax_label": "TVA :",
  "crm.quote_create.submit": "Créer le devis",
  "crm.quote_detail.title": "Devis {number}",
  "crm.quote_detail.fallback": "Devis",
  "crm.quote_detail.desc": "Proposition commerciale — lecture et suivi de statut.",
  "crm.quote_detail.pdf_error": "Génération du PDF impossible.",
  "crm.quote_detail.load_error": "Impossible de charger le devis.",
  "crm.quote_detail.status_changed": "Devis {number} : {status}.",
  "crm.quote_detail.status_error": "Changement de statut impossible.",
  "crm.quote_detail.preview": "Prévisualiser",
  "crm.quote_detail.download": "Télécharger PDF",
  "crm.quote_detail.print": "Imprimer",
  "crm.quote_detail.total_label": "Montant total",
  "crm.quote_detail.valid_until": "Valide jusqu'au",
  "crm.quote_detail.created": "Créé le",
  "crm.quote_detail.lines": "Lignes",
  "crm.quote_detail.discount": "remise {amount}",
  "crm.quote_detail.subtotal": "Sous-total :",
  "crm.quote_detail.tax": "TVA :",
  "crm.quote_detail.total_inline": "Total :",
  "crm.quote_detail.notes": "Notes",
  "crm.quote_detail.history": "Historique",
  "crm.comm_create.title": "Nouvelle interaction",
  "crm.comm_create.desc": "Historique relationnel (V1) : l'échange est consigné, rien n'est envoyé.",
  "crm.comm_create.subject_note": "Titre",
  "crm.comm_create.subject_meeting": "Objet de la réunion",
  "crm.comm_create.subject_default": "Sujet",
  "crm.comm_create.subject_required": "{field} obligatoire.",
  "crm.comm_create.subject_ph_note": "Titre de la note d'échange",
  "crm.comm_create.subject_ph_default": "Sujet de l'échange",
  "crm.comm_create.created": "Interaction consignée.",
  "crm.comm_create.error": "Enregistrement de l'interaction impossible.",
  "crm.comm_create.error_detail": "Enregistrement impossible : {detail}",
  "crm.comm_create.status": "Statut",
  "crm.comm_create.direction": "Direction",
  "crm.comm_create.occurred": "Date de l'échange",
  "crm.comm_create.duration": "Durée (minutes)",
  "crm.comm_create.attachments": "Pièces jointes (nombre)",
  "crm.comm_create.participants": "Participants (séparés par des virgules)",
  "crm.comm_create.participants_ph": "Ex. Taha, contact@client.fr",
  "crm.comm_create.summary": "Résumé",
  "crm.comm_create.summary_ph": "Résumé de l'échange",
  "crm.comm_create.content": "Contenu",
  "crm.comm_create.content_ph": "Contenu détaillé de la note",
  "crm.comm_create.outcome": "Résultat",
  "crm.comm_create.outcome_ph": "Ex. Relance prévue, devis à envoyer…",
  "crm.comm_create.submit": "Consigner l'interaction",
  "crm.ticket_detail.fallback": "Ticket",
  "crm.ticket_detail.desc": "Ticket de support — référence unique des demandes d'assistance.",
  "crm.ticket_detail.load_error": "Impossible de charger le ticket.",
  "crm.ticket_detail.unassigned": "désassigné",
  "crm.ticket_detail.title_required": "Titre obligatoire.",
  "crm.ticket_detail.updated": "Ticket mis à jour.",
  "crm.ticket_detail.update_error": "Mise à jour du ticket impossible.",
  "crm.ticket_detail.update_error_detail": "Mise à jour impossible : {detail}",
  "crm.ticket_detail.status_changed": "Statut : {status}.",
  "crm.ticket_detail.transition_forbidden": "Transition interdite.",
  "crm.ticket_detail.status_error": "Changement de statut impossible.",
  "crm.ticket_detail.category": "Catégorie",
  "crm.ticket_detail.priority": "Priorité",
  "crm.ticket_detail.assignee": "Assigné à",
  "crm.ticket_detail.created_on": "Créé le",
  "crm.ticket_detail.due": "Échéance :",
  "crm.ticket_detail.closed_on": "Fermé le",
  "crm.ticket_detail.description": "Description",
  "crm.ticket_detail.tags": "Tags",
  "crm.ticket_detail.transitions": "Transitions",
  "crm.ticket_detail.history": "Historique",
  "crm.ticket_detail.edit": "Modifier",
  "crm.timeline.title": "Timeline",
  "crm.timeline.subtitle": "Historique chronologique du dossier",
  "crm.timeline.count_one": "{count} événement",
  "crm.timeline.count_other": "{count} événements",
  "crm.timeline.filters_aria": "Filtres de la Timeline",
  "crm.timeline.loading_aria": "Chargement de la Timeline",
  "crm.timeline.error": "Impossible de charger la Timeline.",
  "crm.timeline.empty_1": "Aucun événement pour le moment.",
  "crm.timeline.empty_2": "Les futures actions liées à ce dossier apparaîtront ici.",
  "crm.timeline.filter_empty": "Aucun événement chargé pour ce filtre.",
  "crm.timeline.loading_more": "Chargement…",
  "crm.timeline.load_more": "Charger plus",
  "crm.timeline.load_more_aria": "Charger plus d'événements",
  "crm.timeline.unknown_date": "Date inconnue",
  "crm.timeline.today": "Aujourd'hui",
  "crm.timeline.yesterday": "Hier",
  "crm.timeline.important": "Important",
  "crm.timeline.critical": "Critique",
  "crm.timeline.family.identity": "Identité",
  "crm.timeline.family.acquisition": "Acquisition",
  "crm.timeline.family.crm": "CRM",
  "crm.timeline.family.product": "Produit",
  "crm.timeline.family.commerce": "Commerce",
  "crm.timeline.family.communication": "Communication",
  "crm.timeline.family.support": "Support",
  "crm.timeline.family.decision": "Décision",
  "crm.timeline.family.system": "Système",
  "crm.timeline.filter.all": "Tous",
  "crm.timeline.filter.crm": "CRM",
  "crm.timeline.filter.acquisition": "Acquisition",
  "crm.timeline.filter.commerce": "Commerce",
  "crm.timeline.filter.communication": "Communication",
  "crm.timeline.filter.support": "Support",
  "crm.timeline.filter.decision": "Décisions",
  "crm.timeline.filter.product": "Produit",
  "crm.timeline.filter.system": "Système",

  "crm.decision.card_title": "Actions suggérées",
  "crm.decision.refresh_analysis": "Actualiser l'analyse",
  "crm.decision.subtitle": "Priorités détectées à partir de l'activité du dossier",
  "crm.decision.last_analysis": "— dernière analyse : {time}",
  "crm.decision.error": "Impossible de charger les actions suggérées pour le moment.",
  "crm.decision.synth.priority": "Priorité",
  "crm.decision.synth.potential": "Potentiel",
  "crm.decision.synth.confidence": "Confiance",
  "crm.decision.confidence_badge": "Confiance {level}",
  "crm.decision.limited_title": "Analyse limitée",
  "crm.decision.limited_desc": "Certaines informations du dossier sont insuffisantes pour produire des recommandations fiables.",
  "crm.decision.empty_title": "Aucune action urgente détectée.",
  "crm.decision.empty_desc": "Le dossier ne présente actuellement aucun signal nécessitant une attention particulière.",
  "crm.decision.same_action": "Même action conseillée que ci-dessus.",
  "crm.decision.suggested_action": "Action conseillée : {label}",
  "crm.decision.suggestion_count_title": "{count} suggestions proposent cette même action",
  "crm.decision.acknowledge": "Prendre en compte",
  "crm.decision.dismiss": "Ignorer",
  "crm.decision.history": "Historique",
  "crm.decision.reason_prefix": "Raison : {reason}",
  "crm.decision.show_all": "Voir tout ({count})",
  "crm.decision.collapse": "Réduire",
  "crm.decision.history_section": "Historique des suggestions",
  "crm.decision.history_empty": "Aucune suggestion passée pour ce dossier — rien n'a encore été ignoré ni résolu.",
  "crm.decision.toast_refreshed": "Analyse actualisée.",
  "crm.decision.toast_acknowledged": "Suggestion prise en compte.",
  "crm.decision.toast_ack_error": "Impossible de prendre en compte cette suggestion. Réessayez.",
  "crm.decision.toast_history_error": "Impossible de charger l'historique. Réessayez.",
  "crm.decision.toast_dismissed_until": "Suggestion ignorée jusqu'au {date}.",
  "crm.decision.toast_dismissed_30": "Suggestion ignorée pendant 30 jours.",
  "crm.decision.toast_dismiss_error": "Impossible d'ignorer cette suggestion. Réessayez.",
  "crm.decision.dismiss_dialog_title": "Ignorer cette suggestion pendant 30 jours ?",
  "crm.decision.dismiss_dialog_desc": "Elle sera masquée jusqu'au {date} et pourra réapparaître ensuite si le signal reste vrai. Aucun objet du dossier n'est modifié.",
  "crm.decision.dismiss_reason_ph": "Raison courte (facultatif)",
  "crm.decision.dismiss_busy": "En cours…",
  "crm.decision.dismiss_confirm": "Ignorer 30 jours",

  "crm.manual_prospect.title": "Nouveau prospect",
  "crm.manual_prospect.desc": "Contact rencontré hors des formulaires publics (appel, salon, terrain…). Un Dossier Client officiel est créé immédiatement.",
  "crm.manual_prospect.origin.inbound_call": "Appel entrant",
  "crm.manual_prospect.origin.trade_show": "Salon",
  "crm.manual_prospect.origin.referral": "Recommandation",
  "crm.manual_prospect.origin.field": "Terrain",
  "crm.manual_prospect.origin.whatsapp": "WhatsApp",
  "crm.manual_prospect.origin.partner": "Partenaire",
  "crm.manual_prospect.origin.other": "Autre",
  "crm.manual_prospect.contact.email": "Email",
  "crm.manual_prospect.contact.phone": "Téléphone",
  "crm.manual_prospect.contact.whatsapp": "WhatsApp",
  "crm.manual_prospect.match.email": "email identique",
  "crm.manual_prospect.match.phone": "téléphone identique",
  "crm.manual_prospect.match.email_phone": "email et téléphone identiques",
  "crm.manual_prospect.dup_title": "Un dossier existe déjà pour ce contact.",
  "crm.manual_prospect.dup_desc": "Correspondance détectée : {match}. Aucune création n'a été effectuée.",
  "crm.manual_prospect.conflict_title": "L'email et le téléphone correspondent à deux dossiers différents.",
  "crm.manual_prospect.conflict_desc": "Aucune création n'a été effectuée. Vérifiez les dossiers existants avant de continuer.",
  "crm.manual_prospect.field.first_name": "Prénom",
  "crm.manual_prospect.field.last_name": "Nom",
  "crm.manual_prospect.field.company": "Entreprise",
  "crm.manual_prospect.field.country": "Pays (code)",
  "crm.manual_prospect.field.email": "Email",
  "crm.manual_prospect.field.phone": "Téléphone",
  "crm.manual_prospect.field.origin": "Origine du contact",
  "crm.manual_prospect.field.source_detail": "Détail de l'origine",
  "crm.manual_prospect.field.preferred_contact": "Canal préféré",
  "crm.manual_prospect.field.qualification": "Qualification initiale",
  "crm.manual_prospect.field.assignee": "Responsable",
  "crm.manual_prospect.field.next_action": "Prochaine action",
  "crm.manual_prospect.field.due": "Échéance",
  "crm.manual_prospect.field.notes": "Note interne",
  "crm.manual_prospect.ph.first_name": "Ex. Karim",
  "crm.manual_prospect.ph.last_name": "Ex. Benali",
  "crm.manual_prospect.ph.company": "Ex. Café du Port",
  "crm.manual_prospect.ph.country": "Ex. DZ",
  "crm.manual_prospect.ph.email": "contact@exemple.com",
  "crm.manual_prospect.ph.phone": "+213 555 12 34 56",
  "crm.manual_prospect.ph.source_detail": "Ex. Salon CHR Alger 2026",
  "crm.manual_prospect.ph.assignee": "Ex. Taha",
  "crm.manual_prospect.ph.next_action": "Ex. Rappeler pour démo",
  "crm.manual_prospect.ph.notes": "Contexte de la rencontre (interne uniquement)",
  "crm.manual_prospect.ph.select": "Sélectionner…",
  "crm.manual_prospect.at_least_one": "Au moins un email ou un téléphone est requis.",
  "crm.manual_prospect.open_existing": "Ouvrir le dossier existant",
  "crm.manual_prospect.submit": "Créer le prospect",
  "crm.manual_prospect.toast_created": "Prospect créé. Le Dossier Client est prêt.",
  "crm.manual_prospect.err_first_name": "Le prénom est obligatoire.",
  "crm.manual_prospect.err_origin": "L'origine du contact est obligatoire.",
  "crm.manual_prospect.err_contact": "Renseignez au moins un email ou un téléphone.",
  "crm.manual_prospect.err_email": "Le format de l'email est invalide.",
  "crm.manual_prospect.err_create_detail": "Création impossible : {detail}",
  "crm.manual_prospect.err_create": "Création impossible. Réessayez.",
  // __CRM_KEYS__
};
